//================================================================
//  Component: Dropdown for Fiscal Year Picker
//================================================================

//  Purpose: This is a dropdown component for selecting the fiscal year

//  Properties:
//  1. register: Register the input field to react-hook-form
//  2. errors: Error message for the input field

//  Example:
//  <FiscalYearPicker 
//    register={register}
//    errors={errors} 
//  ></FiscalYearPicker>

//================================================================

export default function FiscalYearPicker({
  register,
  errors
}) {

  /*------------------------------------------------------*/
  /*  Define Constants                                    */
  /*------------------------------------------------------*/

  const currentYear = new Date().getFullYear();
  const startYear = 2020;
  const endYear = currentYear + 5;

  /*------------------------------------------------------*/
  /*  HTML                                                */
  /*------------------------------------------------------*/

  return (
    <div className='flex flex-col'>

      {/* Label */}
      <label className='font-medium mb-1'>
        Fiscal Year<span className='text-[#C4314B]'> *</span>
      </label>

      {/* Select Input Container */}
      <div className='flex items-center border border-gray-300 rounded-md px-3 py-2 w-[300px] bg-white'>

        <span className='mr-2 font-medium text-gray-600'>FY</span>

        <select
          className='flex-1 bg-transparent outline-none'
          {...register('fiscalyear', { required: 'This field is required' })}
        >

          <option hidden value=''>Select</option>

          {Array.from({ length: endYear - startYear + 1 }, (_, i) => {

            const year = startYear + i;

            return (
              <option key={year} value={year}>
                {year}
              </option>

            );

          })}

        </select>

      </div>

      {/* Error Message */}

      {errors.fiscalyear && (
        <p className='text-sm text-[#DE0000] mt-1'>{errors.fiscalyear?.message}</p>
      )}

    </div>
  );

  //------------------------------------------------------

};

